module.exports = __webpack_public_path__ + "img/three1Red.bc1e6c95.jpg";